// Libs
import React, { ReactElement, useEffect, useState } from 'react';
import { IconButton, Icon } from 'ui-components';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
// App
import styles from './bottom-nav-bar.module.scss';

import { isPwa } from 'app-shared/lib/utils/pwa.utils';
import { selectRouterHistory } from '@/redux/router-history.slice';
let lastScrollTop = 0;

const BottomNavBar = (): ReactElement => {
  const router = useRouter();
  const [showNavBar, setShowNavBar] = useState(false);
  const routerHistory = useSelector(selectRouterHistory);

  const handleScroll = () => {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    const isScrollDirectionDown = st > lastScrollTop;

    if (isScrollDirectionDown) {
      setShowNavBar(false);
    } else {
      setShowNavBar(true);
    }

    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  };

  /**
   * Inits nav bar
   */
  useEffect(() => {
    if (isPwa()) {
      window.addEventListener('scroll', handleScroll, false);

      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return (
    (showNavBar && routerHistory.previousRoute && (
      <div className={styles.container}>
        <IconButton className={styles.iconButton} color="secondary" onClick={() => router.back()} size="large">
          <Icon name="left-arrow" />
        </IconButton>
      </div>
    )) ||
    null
  );
};

export default BottomNavBar;
